import { render, staticRenderFns } from "./HighestToLowest.vue?vue&type=template&id=6f443d86&"
import script from "./HighestToLowest.vue?vue&type=script&lang=ts&"
export * from "./HighestToLowest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports